"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ReactNodeToTextUtil_1 = require("../../utils/ReactNodeToTextUtil");
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const TpdModal_style_1 = require("./TpdModal.style");
const TpdModal = (props) => {
    (0, react_1.useEffect)(() => {
        // on modal open
        if (typeof document === "object") {
            const body = document.querySelector("body");
            if (body)
                body.style.overflow = "hidden";
            props.onOpen && props.onOpen();
            // Analytics
            if (props.internalAnalytics) {
                // const titoloElem: HTMLElement | null = document.getElementById('title-modal-for-analytics_' + target.current);
                // const titolo: string = titoloElem?.innerText ?? '';
                const titolo = (0, ReactNodeToTextUtil_1.getNodeText)(props.title);
                // const descrizioneElem: HTMLElement | null = document.getElementById('content-modal-for-analytics_' + target.current);
                // const descrizione = descrizioneElem?.innerText.replace(/(\r\n|\n|\r)/gm, ' ') ?? '';
                const descrizione = (0, ReactNodeToTextUtil_1.getNodeText)(props.content);
                const popup = {
                    popup_type: titolo,
                    popup_detail: descrizione,
                    user_crm_id: ""
                };
                nodejs_library_1.Helpers.SessionHelper.getData("user_crm_id")
                    .then((crmId) => {
                    popup["user_crm_id"] = crmId ? crmId : "";
                    const analyticsService = nodejs_library_1.Providers.AnalyticsService.getInstance();
                    analyticsService.triggerLink(popup);
                }).catch(() => null);
            }
        }
        return () => {
            // on destroy
            // on modal close
            close();
        };
    }, [props.internalAnalytics]);
    const close = () => {
        if (typeof document === "object") {
            const body = document.querySelector("body");
            if (body)
                body.style.overflow = "auto";
        }
        props.onClose && props.onClose();
    };
    return ((0, jsx_runtime_1.jsx)(TpdModal_style_1.TpdModalContainer, Object.assign({ className: `${props.className} tpd-modal-overlay` }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `${props.type === 'default' ? 'tpd-modal-container' : ''} ${props.type === 'custom' ? 'tpd-modal-container-custom' : ''} tpd-modal`, role: "dialog" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "tpd-modal-title title text-center" }, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.title }) })), props.buttonCloseOn && ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "close", onClick: close }, { children: "X" }))), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "tpd-modal-content content" }, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.content }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "tpd-modal-footer footer text-center" }, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.footer }) }))] })) })));
};
exports.TpdModal = TpdModal;
exports.TpdModal.defaultProps = {
    className: '',
    buttonCloseOn: true,
    title: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}),
    content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}),
    footer: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}),
    type: 'default'
};
